import React from 'react';
import { func_cookieSetting, isDateValid, isNumberOrStringValid, isNumberValid, isStringTrimNotEmpty } from 'functions';
import moment from 'moment';

export function useTableColumns() {

    function getColumn_outletID() {
        let columnClassName = "table__column-outlet-id";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Outlet ID",
            id: "outletId",
            accessor: "OutletID",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 300
        }
    }

    function getColumn_outletName() {
        let columnClassName = "table__column-outlet-name";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Outlet Name",
            id: "outletName",
            accessor: "OutletName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 400
        }
    }

    function getColumn_transactionLast2Months() {
        let columnClassName = "table__column-transaction-last-2-months";
    
        return {
            headerCellClassName: columnClassName + " justify-content-start",
            Header: "ST Last 2 Month",
            id: "transactionLast2Months",
            accessor: "STLast2Month",
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isNumberOrStringValid(value))
                    value_formatted = func_cookieSetting.getFormattedPrice(value, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 160
        }
    }

    function getColumn_transactionLast1Month() {
        let columnClassName = "table__column-transaction-last-1-month";
    
        return {
            headerCellClassName: columnClassName + " justify-content-start",
            Header: "ST Last 1 Month",
            id: "transactionLast1Month",
            accessor: "STLastMonth",
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isNumberOrStringValid(value))
                    value_formatted = func_cookieSetting.getFormattedPrice(value, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 160
        }
    }

    function getColumn_transactionRenderMonth() {
        let columnClassName = "table__column-transaction-render-month";
    
        return {
            headerCellClassName: columnClassName + " justify-content-start",
            Header: "ST Render Month",
            id: "transactionRenderMonth",
            accessor: "STRenderMonth",
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isNumberOrStringValid(value))
                    value_formatted = func_cookieSetting.getFormattedPrice(value, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 170
        }
    }

    function getColumn_firstDayOfRenderMonth() {
        let columnClassName = "table__column-first-day-of-render-month";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "First Day Of ST Render Month",
            id: "firstDayOfRenderMonth",
            accessor: "FirstDayOfSTRenderMonth",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isDateValid(value)) 
                    value_formatted = moment(value).format("DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 220
        }
    }

    function getColumn_lastDayOfRenderMonth() {
        let columnClassName = "table__column-last-day-of-render-month";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Last Day Of ST Render Month",
            id: "lastDayOfRenderMonth",
            accessor: "LastDayOfSTRenderMonth",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isDateValid(value)) 
                    value_formatted = moment(value).format("DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 220
        }
    }

    return [
        getColumn_outletID(),
        getColumn_outletName(),
        getColumn_transactionLast2Months(),
        getColumn_transactionLast1Month(),
        getColumn_transactionRenderMonth(),
        getColumn_firstDayOfRenderMonth(),
        getColumn_lastDayOfRenderMonth(),
    ]
}